/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export type SupportedLocale = 'en-US' | 'zh-CN' | 'zh-HK';
export type I18nLanguage = 'en' | 'zh-CN' | 'zh-HK';

export const normalizeLocale = (locale?: string | null): SupportedLocale => {
  const normalized = locale?.trim().replace('_', '-').toLowerCase();

  if (normalized?.startsWith('zh')) {
    if (
      normalized.includes('hant') ||
      normalized.startsWith('zh-tw') ||
      normalized.startsWith('zh-hk') ||
      normalized.startsWith('zh-mo')
    ) {
      return 'zh-HK';
    }
    return 'zh-CN';
  }

  return 'en-US';
};

export const toI18nLanguage = (locale?: string | null): I18nLanguage => {
  const normalized = normalizeLocale(locale);
  return normalized === 'en-US' ? 'en' : normalized;
};

export const isChineseLocale = (locale?: string | null): boolean =>
  normalizeLocale(locale) !== 'en-US';
